/// <amd-module name="SuiteCommerce.Blog.PostCardsCCT"/>
define("SuiteCommerce.Blog.PostCardsCCT", ["require", "exports", "SuiteCommerce.Blog.PostCardsCCT.View"], function (require, exports, PostCardsCCT_View_1) {
    "use strict";
    return {
        mountToApp: function (container) {
            var cms = container.getComponent('CMS');
            cms.registerCustomContentType({
                id: 'cct_sc_blog_article_cards',
                view: PostCardsCCT_View_1.PostCardsCCTView,
                options: {
                    container: container,
                },
            });
        },
    };
});
